export default __webpack_public_path__ + "static/mapa-6873898a9b39f4de2ca0a1b730e19f2f.png";